import { Checkbox } from "@chakra-ui/react";
import { STYTCH_EXTENDED_SESSION_DURATION_DAYS } from "features/auth/StytchUtils";
import React from "react";
import { useTranslation } from "react-i18next";

export interface AuthFactorRememberProps {
  rememberDevice: boolean;
  setRememberDevice: (rememberDevice: boolean) => void;
}

export const AuthFactorRemember: React.FC<AuthFactorRememberProps> = ({
  rememberDevice,
  setRememberDevice,
}) => {
  const { t } = useTranslation(["auth"]);
  return (
    <Checkbox
      isChecked={rememberDevice}
      onChange={(e) => setRememberDevice(e.currentTarget.checked)}
    >
      {t("auth:rememberDevice", {
        count: STYTCH_EXTENDED_SESSION_DURATION_DAYS,
      })}
    </Checkbox>
  );
};
